import { PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../../theme';
import { ChronosphereColorPalette, grey } from '../colors';
import { buildPaletteForMode, type PaletteTokenMetadata, type Token } from '../panw-palette/token-metadata';

const defaultColorTokens = [
  { propertyPath: 'main', tokenName: '--semantic-data-informative-neutral' },
  { propertyPath: 'highContrast', tokenName: '--data-informative-neutral-high-contrast' },
  { propertyPath: 'lowContrast', tokenName: '--data-informative-neutral-low-contrast' },
] satisfies Token[];

export const defaultColorMetadata: PaletteTokenMetadata = {
  componentName: 'status-default',
  tokens: defaultColorTokens,
};

export const defaultColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return buildPaletteForMode<ChronosphereColorPalette>(defaultColorTokens, mode);
  }
  return mode === 'light'
    ? {
        main: grey[400],
        highContrast: grey[700],
        lowContrast: grey[150],
      }
    : {
        main: grey[400],
        highContrast: grey[150],
        lowContrast: grey[800],
      };
};
